import React from 'react';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { SeoMeta } from '@/components/seo/SeoMeta';
import { useCMSContent } from '@/hooks/useCMSContent';
import { renderMarkdown, PageLoading } from './shared';

export const AboutPage = () => {
  const { content, loading } = useCMSContent();

  if (loading) return <PageLoading />;

  const aboutContent = content?.footer?.about_page || 'Innehållet har inte konfigurerats ännu. Gå till Admin > Footer för att redigera.';

  return (
    <div className="bg-[#F8FAFC] min-h-screen" data-testid="about-page">
      <SeoMeta
        title="Om oss"
        description="Läs om ByggFynd — marknadsplatsen som samlar byggmaterial och verktyg från svenska återförsäljare till bra priser."
        canonicalPath="/om-oss"
      />
      <div className="container-main py-8">
        <Breadcrumbs items={[{ label: 'Om oss' }]} />
        
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-black text-[#0F172A] mb-8">Om oss</h1>
          
          <div className="bg-white rounded-md shadow-sm p-8">
            <div className="prose max-w-none">
              {renderMarkdown(aboutContent)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
